import { NotificationList } from 'src/models/NotificationModel';
import { Reducer } from 'redux';
import { SET_NOTIFICATIONS } from 'src/redux/actions/notificationActions';

export type NotificationsState = NotificationList;
const DEFAULT_NOTIFICATIONS: NotificationsState = [] as NotificationsState;
const notificationsReducer: Reducer<NotificationsState> = (state = DEFAULT_NOTIFICATIONS, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return [
        ...action.payload,
      ];
    default:
      return state;
  }
};

export default notificationsReducer;
